import { isObject } from 'lodash';

import { DecimalNumber } from './decimal-number';

const isDecimalNumber = (data: object): boolean => {
  return isObject(data) && data instanceof DecimalNumber;
};

export { isDecimalNumber };
